import { useState } from "react";
import { Download, Printer } from "lucide-react";
import { useApp } from "../context/AppContext";
import { API, useFetch } from "../lib/api";
import { longDate, thisMonth } from "../lib/fmt";
import { PageHeader, Loading, MonthNav, Segmented, Section } from "../components/bits";

function Stat({ n, label }) {
  return <div className="card p-4 text-center"><div className="text-3xl font-bold text-teal-900">{n}</div><div className="text-xs font-semibold text-slate-500">{label}</div></div>;
}

export default function Recap() {
  const { sp, isManager, current } = useApp();
  const [month, setMonth] = useState(thisMonth());
  const [tab, setTab] = useState("me");
  const { data } = useFetch(`/me/recap?month=${month}`);
  const { data: team } = useFetch(isManager && tab === "team" ? sp(`/recap?month=${month}`) : null);
  const csv = tab === "team" ? `${API}${sp(`/recap.csv?month=${month}`)}` : `${API}/me/recap.csv?month=${month}`;
  return (
    <div data-testid="recap-page">
      <PageHeader title="Récapitulatif" back="/" />
      <MonthNav month={month} setMonth={setMonth} label={data?.label || ""} />
      {isManager && <div className="mb-4 print:hidden"><Segmented options={[["me", "Moi"], ["team", current.name]]} value={tab} onChange={setTab} testid="recap-tab" /></div>}
      {tab === "me" ? (!data ? <Loading /> : (
        <>
          <div className="mb-5 grid grid-cols-3 gap-2">
            <Stat n={data.days} label="journées attribuées" /><Stat n={data.done} label="réalisées" /><Stat n={data.missions} label="missions" />
          </div>
          <Section title={data.teams.length ? `Équipes : ${data.teams.join(", ")}` : "Prestations"}>
            <div className="card divide-y divide-slate-100">
              {data.items.length === 0 && <p className="p-4 text-sm text-slate-400">Aucune prestation ce mois-ci.</p>}
              {data.items.map((i, k) => (
                <div key={k} className="flex justify-between gap-2 px-4 py-3 text-sm" data-testid="recap-item">
                  <span><b>{longDate(i.date)}</b> · {i.kind === "day" ? "Tournée" : i.title} · {i.team}</span>
                  <span className={i.done ? "font-bold text-emerald-700" : "text-slate-400"}>{i.kind === "day" ? (i.done ? "Réalisée" : "Planifiée") : "Mission"}</span>
                </div>
              ))}
            </div>
          </Section>
        </>
      )) : (!team ? <Loading /> : (
        <div className="card divide-y divide-slate-100" data-testid="recap-team">
          {team.members.map((m) => (
            <div key={m.user_id} className="px-4 py-3 text-sm">
              <div className="font-bold">{m.name}</div>
              <div className="text-slate-500">{m.days} journée(s) · {m.done} réalisée(s) · {m.missions} mission(s)</div>
            </div>
          ))}
        </div>
      ))}
      <div className="mt-6 grid grid-cols-2 gap-2 print:hidden">
        <a href={csv} className="btn-soft" data-testid="recap-csv-link"><Download className="h-4 w-4" /> CSV</a>
        <button className="btn-ghost" onClick={() => window.print()} data-testid="recap-pdf-btn"><Printer className="h-4 w-4" /> PDF / Imprimer</button>
      </div>
      <p className="mt-3 text-center text-xs text-slate-400">Récapitulatif d'organisation — ce n'est pas une facture INAMI.</p>
    </div>
  );
}
